import { GameController } from '@phosphor-icons/react';

export function WelcomeBackButton({ onPress, caption = 'Nice to See you Back', label = 'Enter the Arcade' }) {
  return (
    <div className="flex flex-col items-center gap-3 py-2" data-testid="welcome-back-block">
      <p className="press3d-caption text-base md:text-lg tracking-[0.18em] uppercase" data-testid="welcome-back-caption">
        {caption}
      </p>
      <button type="button" onClick={onPress} className="press3d" data-testid="welcome-back-button">
        <span className="press3d-shadow" />
        <span className="press3d-edge" />
        <span className="press3d-face">
          <GameController size={22} weight="fill" />
          {label}
        </span>
      </button>
    </div>
  );
}
